import {
  useBoolVariation,
  useNumberVariation,
  useStringVariation,
} from '@launchdarkly/react-sdk';

export const APP_FLAG_KEYS = {
  flagCircuitExport: 'flag-circuit-export',
  flagComputeClearSpansAtRuntime: 'flag-compute-clear-spans-at-runtime',
  flagCycleScheduleCostEstimatorEnabled:
    'flag-cycle-schedule-cost-estimator-enabled',
  flagEnableAnalysisHistoryForAll: 'flag-enable-analysis-history-for-all',
  flagEnableSatelliteBasemap: 'flag-enable-satellite-basemap',
  flagLoadingWheelDelay: 'flag-loading-wheel-delay',
  flagNetworkOutlineWhenFiltering: 'flag-network-outline-when-filtering',
  flagPlannerPublishScenario: 'flag-planner-publish-scenario',
  flagPlannerReliabilityImpactMetrics:
    'flag-planner-reliability-impact-metrics',
  flagPreserveMapState: 'flag-preserve-map-state',
  flagProjectDemo: 'flag-project-demo',
  flagRedFlagWarning: 'flag-red-flag-warning',
  flagReliabilityMetricsConfig: 'flag-reliability-metrics-config',
  flagSelfServiceExports: 'flag-self-service-exports',
  flagShiftSelect: 'flag-shift-select',
  flagUploadProjectFromCsv: 'flag-upload-project-from-csv',
  flagUsePostForMvtGroupAnalysis: 'flag-use-post-for-mvt-group-analysis',
  flagUseNetworkTopologyTables: 'flag-use-network-topology-tables',
  flagAeptxVegetationIntelligenceDashboard:
    'flag-aeptx-vegetation-intelligence-dashboard',
  flagWildfireMode: 'flag-wildfire',
} as const;

export type AppFlagKey = (typeof APP_FLAG_KEYS)[keyof typeof APP_FLAG_KEYS];

export const useAppFlags = () => ({
  flagCircuitExport: useBoolVariation(APP_FLAG_KEYS.flagCircuitExport, false),
  flagComputeClearSpansAtRuntime: useBoolVariation(
    APP_FLAG_KEYS.flagComputeClearSpansAtRuntime,
    false
  ),
  flagCycleScheduleCostEstimatorEnabled: useBoolVariation(
    APP_FLAG_KEYS.flagCycleScheduleCostEstimatorEnabled,
    false
  ),
  flagEnableAnalysisHistoryForAll: useBoolVariation(
    APP_FLAG_KEYS.flagEnableAnalysisHistoryForAll,
    false
  ),
  flagEnableSatelliteBasemap: useBoolVariation(
    APP_FLAG_KEYS.flagEnableSatelliteBasemap,
    false
  ),
  flagLoadingWheelDelay: useNumberVariation(
    APP_FLAG_KEYS.flagLoadingWheelDelay,
    2000
  ),
  flagNetworkOutlineWhenFiltering: useBoolVariation(
    APP_FLAG_KEYS.flagNetworkOutlineWhenFiltering,
    false
  ),
  flagPlannerPublishScenario: useBoolVariation(
    APP_FLAG_KEYS.flagPlannerPublishScenario,
    true
  ),
  flagPlannerReliabilityImpactMetrics: useBoolVariation(
    APP_FLAG_KEYS.flagPlannerReliabilityImpactMetrics,
    false
  ),
  flagPreserveMapState: useBoolVariation(
    APP_FLAG_KEYS.flagPreserveMapState,
    false
  ),
  flagProjectDemo: useBoolVariation(APP_FLAG_KEYS.flagProjectDemo, false),
  flagRedFlagWarning: useBoolVariation(APP_FLAG_KEYS.flagRedFlagWarning, false),
  flagReliabilityMetricsConfig: useBoolVariation(
    APP_FLAG_KEYS.flagReliabilityMetricsConfig,
    false
  ),
  flagSelfServiceExports: useBoolVariation(
    APP_FLAG_KEYS.flagSelfServiceExports,
    false
  ),
  flagShiftSelect: useBoolVariation(APP_FLAG_KEYS.flagShiftSelect, false),
  flagUploadProjectFromCsv: useBoolVariation(
    APP_FLAG_KEYS.flagUploadProjectFromCsv,
    false
  ),
  flagUsePostForMvtGroupAnalysis: useBoolVariation(
    APP_FLAG_KEYS.flagUsePostForMvtGroupAnalysis,
    false
  ),
  flagUseNetworkTopologyTables: useBoolVariation(
    APP_FLAG_KEYS.flagUseNetworkTopologyTables,
    false
  ),
  flagAeptxVegetationIntelligenceDashboard: useBoolVariation(
    APP_FLAG_KEYS.flagAeptxVegetationIntelligenceDashboard,
    false
  ),
  flagWildfireMode: useStringVariation(APP_FLAG_KEYS.flagWildfireMode, 'none'),
});
